import { useEffect } from 'react';
import { KEY_RECOIL } from '@/shared/config';
import { selectActiveTab, selectIsEmptyData, useReportStore } from '@/entities/report';

/**
 * Exposes the Beats and HR tab's active sub-tab and empty-data flag to the tab wrapper. Reads both from the TAB_1 report store and clears the selected strip whenever the tab reports no data.
 *
 * @returns An object carrying activeButton and isEmptyData.
 */
const useWrapReport = () => {
  const keyRecoil = KEY_RECOIL.BEAT_HR;
  const activeButton = useReportStore(selectActiveTab(keyRecoil));
  const isEmptyData = useReportStore(selectIsEmptyData(keyRecoil));
  const setSelectedStripAction = useReportStore((s) => s.actions.setSelectedStrip);
  /**
   * Writes the Beats and HR tab's selected strip. Passes the TAB_1 key with the new selected strip or updater to the store's setSelectedStrip action.
   *
   * @param v - The next selected strip, or an updater receiving the previous one.
   * @returns Nothing.
   */
  const setSelectedStrip = (v: Parameters<typeof setSelectedStripAction>[1]) =>
    setSelectedStripAction(keyRecoil, v);

  useEffect(() => {
    if (isEmptyData) {
      setSelectedStrip(null);
    }
  }, [isEmptyData]);

  return {
    activeButton,
    isEmptyData,
  };
};

export default useWrapReport;
